export default __webpack_public_path__ + "static/media/kitchen3-after1-768w.eeadda78.avif";